import { Injectable } from '@angular/core';
import { LoadingService } from './services/loading/loading.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

/**
 * HTTPリクエストをInterceptしてローディング画面を割り込ませる
 * @export
 * @class LoadingInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable({
  providedIn: 'root'
})
export class LoadingInterceptor implements HttpInterceptor {
  /**
   * コンストラクタ
   * @param {LoadingService} loadingService
   * @memberof LoadingInterceptor
   */
  constructor(public loadingService: LoadingService) { }

  /**
   * HTTPリクエストを識別して処理する
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @return {*}  {Observable<HttpEvent<any>>}
   * @memberof LoadingInterceptor
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // ローディング画面を表示する
    this.loadingService.show();

    return next.handle(request).pipe(finalize(() => {
      // ローディング画面を隠す
      this.loadingService.hide();
    }));
  }

}
